export function createProductionBoardLoadCoordinator() {
  let active = null;

  return {
    run(key, load) {
      const requestKey = String(key || "");
      if (active?.key === requestKey) return active.promise;

      let promise;
      promise = Promise.resolve()
        .then(load)
        .finally(() => {
          if (active?.promise === promise) active = null;
        });
      active = { key: requestKey, promise };
      return promise;
    },

    cancel() {
      active = null;
    },

    has(key) {
      return active?.key === String(key || "");
    },
  };
}
